import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import QuestionSection from "../../ui/QuestionSection/QuestionSection";
import CommonFooter from "../../CommonFooter/CommonFooter";
import CommonButton from "../../ui/CommonButton/CommonButton";
import classes from "./ProcessRequirements.module.css";
import { useAccreditation } from "../../../hooks/useAccreditation";

const ProcessRequirements = () => {
  const { labId } = useParams();
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const [isEditing, setIsEditing] = useState(false);

  const { formData, setFormData, loading, hydrated, fetching, editable, setEditable, handleDone } =
    useAccreditation({
      labId,
      section: "Process Requirements",
      name: "SADCAS F134-B",
      auditorId: user._id,
      isAssessor: user.role === "ASSESSOR",
      isEditing,
      token,
    });

  const handleAnswerChange = (questionId, score, comment, points, content) => {
    setFormData((prev) => ({
      ...prev,
      [questionId]: { score, comment, points, content },
    }));
  };

  const questionSets = [
    {
      questions1: [
        {
          questionId: "Q1",
          content:
            "a. Does the laboratory identify potential risks to patient care in the pre-examination, examination and post-examination processes?",
          number: "7.1",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
        {
          questionId: "Q2",
          content:
            "b. Are the identified risks and effectiveness of the mitigation processes monitored and evaluated according to the potential harm to the patient?",
          number: "",
          multiline: true,
          hideOptions: true,
          placeholder: "Add comment",
        },
      ],
      render: (onAnswerChange, answers) => (
        <QuestionSection
          topQuestion={false}
          addWidth={true}
          questions={questionSets[0].questions1}
          onAnswerChange={editable ? onAnswerChange : () => {}}
          answers={answers}
          disabled={!editable}
        />
      ),
    },
  ];

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet((prev) => prev - 1);
  };

  if (!hydrated || fetching) {
    return <div className={classes.loading}>Loading...</div>;
  }

  return (
    <div className={`${classes.wrapper} ${!editable ? classes.fromParams : ""}`}>
      <div className="d-flex justify-content-between align-items-center">
        <div
          className="d-flex align-items-center gap-2 mb-4"
          onClick={() => navigate(-1)}
          role="button"
        >
          <IoIosArrowRoundBack size={35} />
          <h2 className="m-0">Clause 7: Process Requirements</h2>
        </div>
        {user.role === "ASSESSOR" && !editable && (
          <CommonButton
            className={classes.editButton}
            onClick={() => {
              setIsEditing(true);
              setEditable(true);
            }}
            title="Edit"
          />
        )}
      </div>

      {!editable ? (
        <div className={classes.infoText}>
          ✅ Your SADCAS B - Clause 7: Process Requirements has been submitted.
        </div>
      ) : (
        questionSets[currentSet].render(handleAnswerChange, formData)
      )}

      {editable && (
        <CommonFooter
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          handleDone={handleDone}
          cancelText="Cancel"
          handleCancel={() => setEditable(false)}
          currentSet={currentSet}
          questionSets={questionSets}
          doneText={loading ? "Submitting..." : "Update"}
          disabled={loading}
        />
      )}
    </div>
  );
};

export default ProcessRequirements;